import KendoColorPaletteMixin from './KendoColorPaletteMixin'

export default {
    name: 'kendo-colorpalette',
    mixins: [ KendoColorPaletteMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPalette/index.js